import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import Aboutus from './Aboutus';
import MainBanner from './MainBanner';
import Stack from './Stack';
import ContactForm from './ContactForm';
import Newaboutcompony from './Newaboutcompony';
import NewwhychosesUS from './NewwhychosesUS';
import Testmonial from './Testmonial';
import OurCoPartneres from './OurCoPartneres';
import FastrackYourCarrier from './FastrackYourCarrier';
import PCMobileApplications from './PCMobileApplications';
import ClearPlanB from './ClearPlanB';
import Circle from './Circle';
import Cardudmey from './Cardudmey';
import Coursesnew from './Coursesnew';
import Allcomponanatfilter from './Allcomponanatfilter';
import Newfilterarenge from './Newfilterarenge';
import Alldisplay from './Alldisplay';
import Testfilter from './Testfilter';
import Whychoose from './Whychoose';
import Submitenquery from './Submitenquery';
import Scrennpopup from './Scrennpopup';
import TechStackSection from './TechStackSection';
import InternshipList from './InternshipList';
import FacultiesSection from './FacultiesSection';
import Alumini from './Alumini';
import AboutCompany from './AboutCompany';

const Home = () => {
  // Create ref for InternshipList component
  const internshipRef = useRef(null);

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to scroll to InternshipList
  const scrollToInternships = () => {
    console.log("Scrolling to InternshipList...");
    if (internshipRef.current) {
      internshipRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const location = useLocation();

  // Handle scroll from navigation state
  useEffect(() => {
    if (location.state?.scrollToInternships) {
      setTimeout(() => {
        internshipRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 300);
    }
  }, [location]);

  return (
    <div style={{ backgroundColor: 'white' }}>
      {/* Pass scrollToInternships function as prop to MainBanner */}
      <MainBanner scrollToInternships={scrollToInternships} />
      <AboutCompany/>

      <Scrennpopup />

      {/* <Stack/> */}
      {/* <Filterbar/> */}
      <Newfilterarenge />

      
      {/* Attach ref to InternshipList component */}
      <div ref={internshipRef}>
        <InternshipList />
      </div>
      {/* <FacultiesSection/> */}
      <FastrackYourCarrier />
      <TechStackSection />
      <Alumini />
     
      <Submitenquery />

      <br />

      <style>
        {`
          h1, h2, h3, h4, h5, h6, p {
            font-family: '-apple-system, BlinkMacSystemFont', "SF Pro Text", "SF Pro Display", "Helvetica Neue", Helvetica, Arial, sans-serif;
          }
        `}
      </style>
    </div>
  );
};

export default Home;